<template lang="pug">
div.cm-chips
  v-chip(
    :color='isMultipleMode ? VIOLET_COLOR : "primary"'
    :class="{'text-white': isMultipleMode}"
    v-if="$route.query.city"
  ) {{ currentLocation }}
  v-chip(
    :color='isMultipleMode ? VIOLET_COLOR : "primary"'
    :close="isMultipleMode"
    :class="{'text-white': isMultipleMode}"
    v-for="course in sortedActiveCourses"
    :key="course.ID"
    close-icon="mdi-delete"
    data-test="cm-date"
    @click:close="$emit('delete', course)"
  )
    .overflow-text {{getCourseDate(course) | DOWDutchDDD}} {{getCourseDate(course)}} {{getCourseName(course)}}
  portal-target(name="cm-filters-chips" slim)
</template>

<script>
import {mapGetters, mapState} from "vuex"
import { VIOLET_COLOR } from '../core/cm-const'
export default {
  props: {
    activeCourses: Array,
  },
  data: () => ({
    VIOLET_COLOR
  }),
  methods: {
    getCourseDate(course) {
      return course.date ? course.date : ""
    },
    getCourseName(course) {
      return course.name ? course.name : ""
    }
  },
  computed: {
    sortedActiveCourses() {
      return this.activeCourses.sort((a,b) => new Date(a.date) - new Date(b.date));
    },
    ...mapState('cm', {
      isMultipleMode: state => state.isMultipleMode,
    }),
    ...mapGetters({
      crmCourseLocation: 'crmCourseCities/items'
    }),
    currentLocation() {
      if(!this.$route.query.city || !this.crmCourseLocation) return ''
      let city = this.crmCourseLocation.find(item => item.ID === +this.$route.query.city)
      if(city) return city.name
      return ''
    },
  }
}
</script>

<style lang="scss" scoped>
.cm-chips {
  margin-top: 4px;
  .v-chip {
    margin-right: 8px;
    font-weight: 500;
    max-width: 250px;
    margin-bottom: 16px;
  }

  .text-white{
    color: white;
  }
}
</style>
